<template>
  <div class="container-fluid">
    <!-- TOP ROW (HEADER) -->
    <div class="row h-40">
      <p class="bb-page-title mt-3">LOG</p>
    </div>
    <!-- ------------------- -->
    <!-- MAIN ROW            -->
    <!-- ------------------- -->
    <div class="row">
      <TableLogs
        v-if="logs && loadReady"
        :headings="headings"
        :logs="logs"
      />
    </div>
    <div
      v-if="!loadReady"
      class="bb-loader"
    ></div>
  </div>
</template>

<script>
//========================================================
// scripts
//---------
import { mapActions, mapGetters } from 'vuex'

import TableLogs from '../components/TableLogs.vue'
import handleError from '../helpers/handleError'

export default {
  name: 'LogView',
  //========================================================
  // components
  //------------
  components: {
    TableLogs,
  },
  //========================================================
  // data
  //------
  data() {
    return {
      isSidePanelOpen: false,
      loadReady: false,
      logs: [],
      headings: [
        {
          id: 1,
          label: 'Timestamp',
          field: 'created_at',
          sortable: false,
          width: '210px',
          thClass: 'bb-log-timestamp text-center',
          tdClass: 'bb-log-timestamp text-center',
        },
        {
          id: 2,
          label: 'Type',
          field: 'type',
          sortable: false,
          width: '90px',
          tdClass: 'text-center',
        },
        {
          id: 3,
          label: 'Description',
          field: 'description',
          tdClass: 'text-left',
          sortable: false,
        },
        {
          id: 4,
          label: 'Id',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          hidden: true,
        },
      ],
    }
  },
  //========================================================
  // computed
  //----------
  computed: {
    isInvertedSidePanelOpen() {
      return !this.isSidePanelOpen
    },
  },
  //========================================================
  // methods
  //---------
  methods: {
    ...mapGetters('combat', {
      getCampaign: 'getCampaign',
    }),
    ...mapActions('combat', {
      loadCampaignLog: 'loadCampaignLog',
    }),
    async loadCampaignLogHandler() {
      this.loadReady = false
      let arena_slug = this.getCampaign().slug
      //---------------
      // make API call
      //---------------
      let api_call = this.loadCampaignLog(arena_slug)
      //---------------
      // await results
      //---------------
      await api_call
        .then((logs) => {
          //-----------------
          // get stored logs
          //-----------------
          this.logs = logs
          this.loadReady = true
        })
        .catch((err) => {
          handleError(err, 43)
        })
    },
  },
  //========================================================
  // mounted
  //----------
  mounted() {
    //------------------------
    // load campaign log handler
    //------------------------
    this.loadCampaignLogHandler()
  },
}
</script>
